export let registerMapData = [
  {
    id: '1',
    label: 'Common 1',
    moduleName: 'Common 1',
    instanceName: "Common 1 - instance",
    baseAddress: 'Common 1 - baseAddress',
    children: [
      {
        id: '3',
        label: ' Register 1',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '33',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '35',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '4',
        label: 'Register 2',
        regName: 'Register2 - regName',
        offset: "Register2 - offset",
        children: [

        ]
      },
      {
        id: '5',
        label: ' Register 3',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '53',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '55',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '6',
        label: ' Register 4',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '63',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '65',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '7',
        label: ' Register 5',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '73',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '75',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '8',
        label: ' Register 6',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '83',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '85',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '9',
        label: ' Register 7',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '93',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '95',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '100',
        label: ' Register 8',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '1003',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '1005',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '11',
        label: ' Register 9',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '113',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '115',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '12',
        label: ' Register 10',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '123',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '125',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
      {
        id: '13',
        label: ' Register 11',
        regName: 'Register1 - regName',
        offset: "Register1 - offset",
        children: [
          {
            id: '133',
            label: 'Field 1',
            name: 'Field 1',
            fieldType: "readable",
            bitPosition: "0000",
            desription: "desc",
            defaultValue: '111',
          },
          {
            id: '135',
            label: 'Field 2',
            name: 'Field 2',
            fieldType: "readable",
            bitPosition: "1111",
            desription: "desc",
            defaultValue: '111',
          }
        ]
      },
    ],
  },
  {
    id: '6', label: 'Common 2', label: 'Common 2',
    moduleName: 'Common 2',
    instanceName: "Common 2 - instance",
    baseAddress: 'Common 2 - baseAddress',
    children: []
  },
];